








































import { iComResponse, OWebLogin } from "oweb";
import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

const getLoginForm = function() {
	return {
		fields: {
			phone: {
				field: "phone",
				attrs: {
					name: "phone",
					autofocus: "autofocus",
					autocomplete: "off"
				},
				label: { i18n: "OO_LANG_PHONE" }
			},
			pass: {
				field: "input",
				label: { i18n: "OO_LANG_PASSWORD" },
				attrs: {
					name: "pass",
					type: "password",
					"data-oweb-form-v": "login_pass"
				}
			},
			submit: { field: "submit", i18n: "OO_LANG_LOGIN" }
		}
	};
};

@Component
export default class PUserLogin extends BaseComponent {
	get form() {
		return getLoginForm();
	}

	login(event: any) {
		let form = <HTMLFormElement>event.target,
			log = new OWebLogin(app),
			ctx = this;
		log.onSuccess(function(response: iComResponse) {
			app.user
				.setCurrentUser(response.data)
				.setSessionExpire(response.stime!);

			setTimeout(function() {
				ctx.finish();
			}, 500);
		})
			.onError(function(response: iComResponse) {
				app.view.dialog(response);
			})
			.loginWithPhone(form);
	}

	finish() {
		let rCtx = app.store.routeContext,
			_return =
				rCtx.getStateItem("return") || rCtx.getSearchParam("return"),
			next =
				<string>rCtx.getStateItem("next") ||
				rCtx.getSearchParam("next") ||
				this.ow_route_link("/");

		if (_return) {
			app.router.goBack();
		} else {
			if (rCtx.getSearchParam("auth")) {
				(window as any).location = next;

				return;
			}
			app.router.browseTo(next, undefined, false);
		}
	}
}
